<div
  class="socials"
  [class.inline]="inline"
  [class.not-inline]="!inline"
>

  <ng-content></ng-content>

  <div
    *ngIf="includeResumeButton && candidate?.isNotAnonymized"
    class="resume-icon"
  >
    <a
      mat-mini-fab
      target="_blank"
      rel="noopener noreferrer"
      [ngClass]="{'social-mini': mini, 'social': !mini}"
    >
      <mojo-candidate-resume-link [candidate]="candidate">
        <mat-icon matTooltip="Download resume">cloud_download</mat-icon>
      </mojo-candidate-resume-link>
    </a>
  </div>

  <div
    *ngIf="includeContactButtons && candidate?.visibleMail"
    class="contact-icon"
  >
    <a
      mat-mini-fab
      target="_blank"
      rel="noopener noreferrer"
      href="mailto:{{ candidate?.mail }}"
      [ngClass]="{'social-mini': mini, 'social': !mini}"
    >
      <mat-icon>email</mat-icon>
    </a>
  </div>

  <div
    *ngIf="includeContactButtons && candidate?.mobile"
    class="contact-icon"
  >
    <a
      mat-mini-fab
      target="_blank"
      rel="noopener noreferrer"
      href="tel:{{ candidate?.mobile }}"
      [ngClass]="{'social-mini': mini, 'social': !mini}"
    >
      <mat-icon>phone</mat-icon>
    </a>
  </div>

  <div
    *ngFor="let social of socials"
    class="social-icon"
  >
    <a
      [attr.data-cy]="'social-links-media-link-' + social.type"
      [href]="social.url"
      [ngClass]="{'social-mini': mini, 'social': !mini}"
      mat-mini-fab
      rel="noopener noreferrer"
      target="_blank"
    >
      <mat-icon
        [svgIcon]="social.type"
        [ngClass]="{'custom-mini': mini}"
        *ngIf="social.type !== 'website'"
      >link</mat-icon>
      <mat-icon
        *ngIf="social.type === 'website'"
        class="inherited"
        [ngClass]="{'extra-small-icon': mini}"
      >link
      </mat-icon>
    </a>
  </div>
</div>
